document.addEventListener("DOMContentLoaded", function() {
    let locationField = document.getElementById("input_1_8");

    if (locationField) {
        let apiKey = "<?php echo esc_js(IPINFO_API_KEY); ?>";

        fetch(`https://ipinfo.io/json?token=${apiKey}`)
            .then(response => response.json())
            .then(data => {
                locationField.value = data.country;
            })
            .catch(error => console.log("Error fetching location:", error));
    }
});